export function useWishlistItemToggle(item: MaybeRefOrGetter<WishlistItem>) {
  const partner = usePartnerStore()
  const bookmarks = useBookmarks()
  const wishlist = useWishlist()

  const isBookmarked = computed(() => bookmarks.has(toValue(item).code))

  function toggle() {
    if (partner.isB2B) {
      bookmarks.toggle(toValue(item).code)
    } else {
      wishlist.toggle(toValue(item), !isBookmarked.value)
    }
  }

  function edit() {
    wishlist.edit(toValue(item))
  }

  return { isBookmarked, toggle, edit }
}
